<script>
  import { mapGetters } from 'vuex';
  import FilterItem from '@/components/MainFilter/FilterItem';
  import VSelect from '@/components/Common/VSelect';
  import VSelectSearch from '@/components/Common/VSelectSearch';
  import VInput from '@/components/Common/VInput';
  import VueSlider from 'vue-slider-component';
  import 'vue-slider-component/theme/antd.css';
  import Scrollbar from 'smooth-scrollbar';
  import priceFormat from '@/utils/priceFormat';
  import wordEnding from '@/utils/wordEnding';
  import cookies from 'vue-cookies';
  import _ from 'lodash';
  import ClearFilter from '../Svg/Filter/ClearFilter.vue';

  const SETTINGS_SLIDER = {
    dotSize: 16,
    dotStyle: {
      backgroundColor: '#eff0f3',
      border: '5px solid #95CA51',
    },
    railStyle: {
      backgroundColor: '#eff0f3',
    },
    processStyle: {
      border: '1px solid #95CA51',
      backgroundColor: '#95CA51',
    },
  };

  export default {
    name: 'FilterComponent',
    components: {
      FilterItem,
      VInput,
      VueSlider,
      VSelect,
      VSelectSearch,
      ClearFilter,
    },
    props: {
      countCarsCurrentCity: {
        type: Number,
        required: true,
      },
      checkboxes: {
        type: Array,
      },
      filterData: {
        type: Object,
        default: () => ({}),
      },
      filterPageData: {
        type: Object,
        default: () => ({}),
      },
      typePage: {
        type: String,
        required: true,
      },
      isLanding: {
        type: Boolean,
        default: false,
      },
    },
    priceFormat,
    wordEnding,
    SETTINGS_SLIDER,
    cookies,
    data() {
      return {
        currentFilterData: this.filterData,
        currentCountCityCars: this.countCarsCurrentCity,
        showMore: false,
        nds: null,
        credit: null,
        filters: {
          hot_offer: null,
          created_at: null,
          brands: [],
          models: [],
          credit: null,
          bodies: [],
          fuel: [],
          kpp: [],
          min_probeg: null,
          power: {
            min: null,
            max: null,
          },
          mileage: {
            min: null,
            max: null,
          },
          year: [],
          volumes: {
            min: null,
            max: null,
          },
          price: {
            min: null,
            max: null,
          },
          dealers: [],
        },
        sliders: {
          power: [null, null],
          mileage: [null, null],
          volumes: [null, null],
          price: [null, null],
        },
        firstUpload: true,
        openedFilter: false,
        checkboxes: this.checkboxes,
        isNewCarsPage: window.location.pathname.includes('/cars/new'),
      };
    },
    watch: {
      countCityCars() {
        this.currentCountCityCars = this.countCityCars;
      },
      'filters.brands'() {
        this.$emit('change-filters', this.filters);
      },
      'filters.nds'() {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.credit'() {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.models'(val) {
        this.$emit('change-filters', this.filters);
      },
      'filters.colors'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.year'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.bodies'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.kpp'(newVal, oldVal) {
        const diff = _.difference(newVal, oldVal);
        if (diff?.length && diff[0]?.id === 2) {
          if (!this.filters.kpp.filter(item => item.id === 3).length) {
            this.filters.kpp.push({ id: 3, name: 'Робот' });
          }
          if (!this.filters.kpp.filter(item => item.id === 4).length) {
            this.filters.kpp.push({ id: 4, name: 'Вариатор' });
          }
        }
        const vals = newVal.map(e => e.id);
        if (vals.includes(2) && !vals.includes(3) && !vals.includes(4)) {
          this.filters.kpp = this.filters.kpp.filter(e => e.id !== 2);
        }
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.gear'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.fuel'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.owners'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.has_warranty'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.dealers'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.min_probeg'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.one_owner'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.cool_cars'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.for_family'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.has_warranty'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.nizkiy_nalog'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      'filters.novinki_nedeli'(val) {
        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      },
      filterParams() {
        this.currentFilterData = this.filterParams;
      },
      waitForRequestFilterParams(value) {
        if (value) {
          this.removeUnwantedElement();

          this.$emit('change-filters', this.filters);
        }
      },
      selectedData() {
        if (Object.keys(this.selectedData).length > 0) {
          this.selectionPrimaryData(this.selectedData);
          this.$emit('change-filters', this.filters);
          setTimeout(() => {
            this.$emit('update-filter');
          }, 0);
        }
      },
    },
    created() {
      this.$nextTick(() => {
        document.querySelectorAll('.scrollbar').forEach(element => {
          Scrollbar.init(element, {
            alwaysShowTracks: true,
          });
        });
      });

      this.updateFiltersFromGetParams();

      if (Object.keys(this.filterPageData).length > 0) {
        this.selectionPrimaryData(this.filterPageData);
      }

      this.insertDefaultParams();
    },
    computed: {
      ...mapGetters({
        filterParams: 'Filter/filterParams',
        waitForRequestFilterParams: 'Filter/waitForRequestFilterParams',
        selectedData: 'Filter/selectedData',
        countCityCars: 'Filter/countCityCars',
      }),
    },
    methods: {
      getParams() {
        const query = window.location.search.replace('?', '').split('&');
        let params = {};

        if (window.location.search !== '') {
          query.forEach(element => {
            if (element.includes('%5B%5D')) {
              if (!params[element.split('=')[0].replace('%5B%5D', '')]) {
                params[element.split('=')[0].replace('%5B%5D', '')] = [];
              }
              params[element.split('=')[0].replace('%5B%5D', '')].push(
                element.split('=')[1],
              );
            } else {
              params[element.split('=')[0]] = element.split('=')[1];
            }
          });
        }
        return params;
      },
      showAll() {
        this.showMore = !this.showMore;
      },
      updateFiltersFromGetParams() {
        if (window.location.search !== '') {
          Object.entries(this.getParams()).forEach(([key, value]) => {
            if (value) {
              if (this.filters && typeof value === 'string') {
                if (this.checkboxes.includes(key)) {
                  this.filters[key] = this.filterData[key];
                } else if (key.includes('min')) {
                  if (this.filters[key.replace('_min', '')])
                    this.filters[key.replace('_min', '')].min = value;
                  if (this.sliders[key.replace('_min', '')])
                    this.sliders[key.replace('_min', '')][0] = value;
                } else if (key.includes('max')) {
                  if (this.filters[key.replace('_max', '')])
                    this.filters[key.replace('_max', '')].max = value;
                  if (this.sliders[key.replace('_max', '')])
                    this.sliders[key.replace('_max', '')][1] = value;
                }
              } else {
                value.forEach(item => {
                  if (!this.filters[key]) {
                    this.filters[key] = [];
                  }

                  const currentItem = this.filterData[key].find(
                    e => e.id === Number(item),
                  );
                  if (currentItem) {
                    this.filters[key].push(currentItem);
                  }
                });
              }
            }
          });
        }
      },
      insertDefaultParams() {
        Object.keys(this.sliders).forEach(name => {
          if (!this.filters[name].min && this.filterData[name]?.min >= 0) {
            this.filters[name].min = this.filterData[name].min;
            this.sliders[name][0] = this.filterData[name].min;
          }

          if (!this.filters[name].max && this.filterData[name]?.max >= 0) {
            this.filters[name].max = this.filterData[name].max;
            this.sliders[name][1] = this.filterData[name].max;
          }
        });
      },
      removeUnwantedElement() {
        Object.keys(this.filters).forEach(name => {
          if (this.filters[name] instanceof Array) {
            let ids = [];
            this.currentFilterData[name].forEach(item => {
              ids.push(item.id);
            });

            this.filters[name] = this.filters[name].filter(e =>
              ids.includes(e.id),
            );
          }
        });
      },
      selectionPrimaryData(data) {
        if (
          data['brand'] >= 0 &&
          !this.filters.brands.some(
            e =>
              e.id === data['brand'] &&
              this.filterData.allBrands.some(e => e.id === data['brand']),
          )
        ) {
          this.filters.brands.push(
            this.filterData.allBrands.find(e => e.id === data['brand']),
          );
        }
        if (
          data['model'] >= 0 &&
          !this.filters.models.some(e => e.id === data['model']) &&
          this.filterData.models_all.some(e => e.id === data['model'])
        ) {
          this.filters.models.push(
            this.filterData.models_all.find(e => e.id === data['model']),
          );
          this.filterData.models.push(
            this.filterData.models_all.find(e => e.id === data['model']),
          );
        }
      },
      getGroups(name) {
        let groups = [];
        this.currentFilterData[name].forEach(element => {
          if (element.group_name && !groups.includes(element.group_name)) {
            groups.push(element.group_name);
          }
        });
        return groups;
      },
      addingToObject(name) {
        const object = {
          name: name,
          group: true,
        };
        return object;
      },
      isItemSelected(item, name) {
        if (this.filters[name]) {
          if (this.checkboxes.includes(name)) {
            return !!this.filters[name];
          } else if (item.group) {
            const itemsWithGroup = this.currentFilterData[name].filter(
              e => e.group_name === item.name,
            );
            const filtersItemsWithGroup = this.filters[name].filter(
              e => e.group_name === item.name,
            );

            return itemsWithGroup.length === filtersItemsWithGroup.length;
          } else {
            return this.filters[name].some(e => e.id === item.id);
          }
        } else {
          return false;
        }
      },
      itemSelection(item, checked, name) {
        if (this.checkboxes.includes(name)) {
          this.filters[name] = !!this.filters[name] ? null : item;
        } else {
          if (this.filters[name]?.find(e => e.id === item.id)) {
            this.filters[name] = this.filters[name].filter(e => e.id !== item.id);
          } else {
            if (item.group) {
              const itemsWithGroup = this.currentFilterData[name].filter(
                e => e.group_name === item.name,
              );
              const itemsWithoutGroup = this.filters[name].filter(
                e => !e.group_name,
              );

              if (checked) {
                this.filters[name] = itemsWithoutGroup;
              } else {
                this.filters[name] = itemsWithGroup.concat(itemsWithoutGroup);
              }
            } else {
              if (!this.filters[name]) {
                this.filters[name] = [];
              }
              this.filters[name].push(item);
            }
          }
        }
      },
      updateFilterDebounce: _.debounce(function () {

        this.$emit('change-filters', this.filters);
        this.$emit('update-filter');
      }, 700),
      changeInputSlider(name) {
        this.sliders[name] = [this.filters[name].min, this.filters[name].max];
        this.updateFilterDebounce();
      },
      changeSlider: _.debounce(function () {
        Object.keys(this.sliders).forEach(name => {
          const data = {
            min: this.sliders[name][0],
            max: this.sliders[name][1],
          };

          this.filters[name] = data;
        });
        this.updateFilterDebounce();
      }, 700),
      resetAllFilter() {
        const initialValues = this.$options.data.apply(this).filters;
        this.filters = initialValues;
      },
      showFilter() {
        this.openedFilter = !this.openedFilter;
        if (!this.openedFilter) {
          window.scrollBy({
            top:
              document.querySelector('#filter-cars').getBoundingClientRect().top -
              50,
            behavior: 'smooth',
          });
        }
      },
      scrollToList() {
        window.scrollBy({
          top:
            document.querySelector('#car-sort').getBoundingClientRect().top - 50,
          behavior: 'smooth',
        });
      },
    },
  };
</script>

<template v-if="currentFilterData">
  <div class="flex-shrink w-full">
    <button
      class="button button_green button_big w-full lg:hidden mb-5"
      @click="showFilter"
    >
      {{ openedFilter ? 'Показать машины' : 'Фильтр' }}
    </button>
    <div
      class="lg:block rounded-big-brand bordered mb-5 bg-white"
      :class="{ hidden: !openedFilter }"
    >
      <div class="flex flex-wrap p-5 relative">
        <div v-if="currentFilterData?.brands" class="p-2 w-full lg:w-1/6">
          <v-select-search
            v-model="filters.brands"
            :options="currentFilterData.brands"
            theme="white"
            classesInput="text-black"
            placeholder="Марка"
            class="md:w-full bg-gray-202"
            label="name"
            multiple
          />
        </div>

        <div v-if="currentFilterData?.models" class="p-2 w-full lg:w-1/6">
          <v-select-search
            v-model="filters.models"
            :options="currentFilterData.models"
            theme="white"
            placeholder="Модель"
            class="md:w-full bg-gray-202"
            label="name"
            multiple
          />
        </div>
        <div v-if="currentFilterData?.year" class="p-2 w-full lg:w-1/6">
          <v-select-search
            v-model="filters.year"
            :options="currentFilterData.year.map(e => {
              return { id: e.name, name: e.name };
            })
              "
            theme="white"
            placeholder="Год"
            class="md:w-full bg-gray-202"
            label="name"
            multiple
          />
        </div>

        <div v-if="currentFilterData?.price" class="p-2 w-full lg:w-1/4">
          <div>
            <div class="relative flex items-center space-x-2">
              <v-input
                v-model="filters.price.min"
                theme="gray"
                format="price"
                class="bg-gray-202 rounded-brand"
                classesInput="py-1.5 px-2 text-xxs"
                classes-input="!text-green"
                prefix="Цена от"
                prefixPadding="pl-[4.5rem]"
                sufix=" руб."
                :min="currentFilterData.price.min"
                :max="currentFilterData.price.max"
                :followInput="false"
                @change="changeInputSlider('price')"
                @keyup="changeInputSlider('price')"
              />
              <div class="relative w-3.5 h-px bg-gray-400"></div>
              <v-input
                v-model="filters.price.max"
                theme="gray"
                format="price"
                class="bg-gray-202 rounded-brand"
                classesInput="py-1.5 px-2 text-sm"
                classes-input="!text-green"
                prefix="до"
                sufix=" руб."
                :min="currentFilterData.price.min"
                :max="currentFilterData.price.max"
                :followInput="false"
                @change="changeInputSlider('price')"
                @keyup="changeInputSlider('price')"
              />
            </div>
            <vue-slider
              v-model="sliders.price"
              :min="currentFilterData.price.min"
              :max="currentFilterData.price.max"
              :tooltip="'none'"
              :interval="1"
              :dot-size="$options.SETTINGS_SLIDER.dotSize"
              :dot-style="$options.SETTINGS_SLIDER.dotStyle"
              :rail-style="$options.SETTINGS_SLIDER.railStyle"
              :process-style="$options.SETTINGS_SLIDER.processStyle"
              class="mt-2 mx-2"
              :enableCross="false"
              @change="changeSlider('price')"
            />
          </div>
        </div>

        <div v-if="currentFilterData?.mileage" class="p-2 w-full lg:w-1/4">
          <div>
            <div class="relative flex items-center space-x-2">
              <v-input
                v-model="filters.mileage.min"
                theme="gray"
                format="price"
                class="bg-gray-202 rounded-brand"
                classesInput="py-1.5 px-2 text-sm"
                sufix=" км"
                prefixPadding="pl-[5.5rem]"
                prefix="Пробег от"
                classes-input="!text-green"
                :min="currentFilterData.mileage.min"
                :max="currentFilterData.mileage.max"
                :followInput="false"
                @change="changeInputSlider('mileage')"
                @keyup="changeInputSlider('mileage')"
              />
              <div class="relative w-3.5 h-px bg-gray-400"></div>
              <v-input
                v-model="filters.mileage.max"
                theme="gray"
                format="price"
                class="bg-gray-202 rounded-brand"
                classesInput="py-1.5 px-2 text-sm"
                sufix=" км"
                prefix="до"
                classes-input="!text-green"
                :min="currentFilterData.mileage.min"
                :max="currentFilterData.mileage.max"
                :followInput="false"
                @change="changeInputSlider('mileage')"
                @keyup="changeInputSlider('mileage')"
              />
            </div>
            <vue-slider
              v-model="sliders.mileage"
              :min="currentFilterData.mileage.min"
              :max="currentFilterData.mileage.max"
              :tooltip="'none'"
              :interval="1"
              :dot-size="$options.SETTINGS_SLIDER.dotSize"
              :dot-style="$options.SETTINGS_SLIDER.dotStyle"
              :rail-style="$options.SETTINGS_SLIDER.railStyle"
              :process-style="$options.SETTINGS_SLIDER.processStyle"
              class="mt-2 mx-2"
              :enableCross="false"
              @change="changeSlider('mileage')"
            />
          </div>
        </div>

        <div class="p-2 w-full lg:w-1/6" v-if="!showMore">
          <div
            data-toggle="[data-used-toggle]"
            :class="{ hidden: showMore }"
            class="relative w-full leading-none text-center font-medium underline cursor-pointer py-3.5 px-3 border rounded-lg bg-white border-gray-200 md:w-full bg-gray-202"
            @click="showAll()"
          >
            Показать все параметры
          </div>
        </div>
        <div class="flex flex-row items-center" v-if="!showMore">
          <div class="p-2" v-if="currentFilterData?.credit">
            <filter-item
              v-model="filters.credit"
              :item="currentFilterData.credit"
              name="credit"
              :disabled="isItemSelected(currentFilterData.nds, 'nds')"
              :is-item-selected="isItemSelected(currentFilterData.credit, 'credit')
                "
              @on-item-click="itemSelection"
            >
            </filter-item>
          </div>
          <div class="p-2" v-if="currentFilterData?.nds">
            <filter-item
              v-model="filters.nds"
              :item="currentFilterData.nds"
              name="nds"
              :is-item-selected="isItemSelected(currentFilterData.nds, 'nds')"
              :disabled="isItemSelected(currentFilterData.credit, 'credit')"
              @on-item-click="itemSelection"
            >
            </filter-item>
          </div>
        </div>
        <div data-used-toggle class="!hidden flex flex-wrap w-full">
          <div v-if="showMore && filters.bodies" class="p-2 w-full lg:w-1/6">
            <v-select-search
              v-model="filters.bodies"
              :options="currentFilterData.bodies"
              theme="white"
              placeholder="Кузов"
              class="md:w-full bg-gray-202"
              label="name"
              multiple
            />
          </div>
          <div v-if="currentFilterData?.colors" class="p-2 w-full lg:w-1/6">
            <v-select-search
              v-model="filters.colors"
              :options="currentFilterData.colors"
              theme="white"
              placeholder="Цвет"
              class="md:w-full bg-gray-202"
              label="name"
              multiple
            />
          </div>

          <div v-if="currentFilterData?.kpp" class="p-2 w-full lg:w-1/6">
            <v-select-search
              v-model="filters.kpp"
              :options="currentFilterData.kpp"
              theme="white"
              placeholder="КПП"
              class="md:w-full bg-gray-202"
              label="name"
              multiple
            />
          </div>

          <div v-if="currentFilterData?.power" class="p-2 w-full lg:w-1/4">
            <div>
              <div class="relative flex items-center space-x-2">
                <v-input
                  v-model="filters.power.min"
                  theme="gray"
                  format="number"
                  class="bg-gray-202 rounded-brand"
                  classesInput="py-1.5 px-2 text-sm"
                  sufix=" л.с"
                  prefixPadding="pl-[7rem]"
                  prefix="Мощность от"
                  classes-input="!text-green"
                  :min="currentFilterData.power.min"
                  :max="currentFilterData.power.max"
                  :followInput="false"
                  @change="changeInputSlider('power')"
                  @keyup="changeInputSlider('power')"
                />
                <div class="relative w-3.5 h-px bg-gray-400"></div>
                <v-input
                  v-model="filters.power.max"
                  theme="gray"
                  format="number"
                  class="bg-gray-202 rounded-brand"
                  classesInput="py-1.5 px-2 text-sm"
                  sufix=" л.с"
                  prefix="до"
                  classes-input="!text-green"
                  :min="currentFilterData.power.min"
                  :max="currentFilterData.power.max"
                  :followInput="false"
                  @change="changeInputSlider('power')"
                  @keyup="changeInputSlider('power')"
                />
              </div>
              <vue-slider
                v-model="sliders.power"
                :min="currentFilterData.power.min"
                :max="currentFilterData.power.max"
                :tooltip="'none'"
                :interval="1"
                :dot-size="$options.SETTINGS_SLIDER.dotSize"
                :dot-style="$options.SETTINGS_SLIDER.dotStyle"
                :rail-style="$options.SETTINGS_SLIDER.railStyle"
                :process-style="$options.SETTINGS_SLIDER.processStyle"
                class="mt-2 mx-2"
                :enableCross="false"
                @change="changeSlider('power')"
              />
            </div>
          </div>
          <div v-if="currentFilterData?.volumes" class="p-2 w-full lg:w-1/4">
            <div>
              <div class="relative flex items-center space-x-2">
                <v-input
                  v-model="filters.volumes.min"
                  theme="gray"
                  format="number"
                  class="bg-gray-202 rounded-brand"
                  classesInput="py-1.5 px-2 text-sm"
                  sufix=" л"
                  prefix="Объем от"
                  prefixPadding="pl-[5.5rem]"
                  classes-input="!text-green"
                  :min="currentFilterData.volumes.min"
                  :max="currentFilterData.volumes.max"
                  :followInput="false"
                  @change="changeInputSlider('volumes')"
                  @keyup="changeInputSlider('volumes')"
                />
                <div class="relative w-3.5 h-px bg-gray-400"></div>
                <v-input
                  v-model="filters.volumes.max"
                  theme="gray"
                  format="number"
                  class="bg-gray-202 rounded-brand"
                  classesInput="py-1.5 px-2 text-sm"
                  sufix=" л"
                  prefix="до"
                  classes-input="!text-green"
                  :min="currentFilterData.volumes.min"
                  :max="currentFilterData.volumes.max"
                  :followInput="false"
                  @change="changeInputSlider('volumes')"
                  @keyup="changeInputSlider('volumes')"
                />
              </div>
              <vue-slider
                v-model="sliders.volumes"
                :min="currentFilterData.volumes.min"
                :max="currentFilterData.volumes.max"
                :tooltip="'none'"
                :interval="0.1"
                :dot-size="$options.SETTINGS_SLIDER.dotSize"
                :dot-style="$options.SETTINGS_SLIDER.dotStyle"
                :rail-style="$options.SETTINGS_SLIDER.railStyle"
                :process-style="$options.SETTINGS_SLIDER.processStyle"
                class="mt-2 mx-2"
                :enableCross="false"
                @change="changeSlider('volumes')"
              />
            </div>
          </div>
          <div v-if="currentFilterData?.gear" class="p-2 w-full lg:w-1/6">
            <v-select-search
              v-model="filters.gear"
              :options="currentFilterData.gear"
              theme="white"
              placeholder="Привод"
              class="md:w-full bg-gray-202"
              label="name"
              multiple
            />
          </div>
          <div v-if="currentFilterData?.fuel" class="p-2 w-full lg:w-1/6">
            <v-select-search
              v-model="filters.fuel"
              :options="currentFilterData.fuel"
              theme="white"
              placeholder="Двигатель"
              class="md:w-full bg-gray-202"
              label="name"
              multiple
            />
          </div>
          <div v-if="currentFilterData?.owners" class="p-2 w-full lg:w-1/6">
            <v-select-search
              v-model="filters.owners"
              :options="currentFilterData.owners"
              theme="white"
              placeholder="Владельцы"
              class="md:w-full bg-gray-202"
              label="name"
              multiple
            />
          </div>
          <div
            v-if="currentFilterData?.has_warranty"
            class="p-2 w-full lg:w-1/6"
          >
            <v-select-search
              v-model="filters.has_warranty"
              :options="[
                { id: 0, name: 'нет' },
                { id: 1, name: 'да' },
              ]"
              theme="white"
              placeholder="Гарантия"
              class="md:w-full bg-gray-202"
              label="name"
            />
          </div>
          <div v-if="currentFilterData?.dealers" class="p-2 w-full lg:w-1/6">
            <!--noindex-->
            <v-select-search
              v-model="filters.dealers"
              :options="currentFilterData.dealers"
              theme="white"
              placeholder="Автосалон"
              class="md:w-full bg-gray-202"
              label="name"
              multiple
            />
            <!--/noindex-->
          </div>
          <div class="flex flex-row items-center">
            <div class="p-2" v-if="currentFilterData?.credit">
              <filter-item
                v-model="filters.credit"
                :item="currentFilterData.credit"
                name="credit"
                :disabled="isItemSelected(currentFilterData.nds, 'nds')"
                :is-item-selected="isItemSelected(currentFilterData.credit, 'credit')
                  "
                @on-item-click="itemSelection"
              >
              </filter-item>
            </div>
            <div class="p-2" v-if="currentFilterData?.nds">
              <filter-item
                v-model="filters.nds"
                :item="currentFilterData.nds"
                name="nds"
                :is-item-selected="isItemSelected(currentFilterData.nds, 'nds')"
                :disabled="isItemSelected(currentFilterData.credit, 'credit')"
                @on-item-click="itemSelection"
              >
              </filter-item>
            </div>
          </div>
          <div
            data-used-toggle
            data-toggle="[data-used-toggle]"
            v-if="showMore"
            class="!hidden flex underline justify-center mt-[10px] text-base p-2 w-full cursor-pointer border rounded-lg border-gray-200 mx-[0.5rem] bg-gray-500 text-white"
            @click="showAll()"
          >
            Свернуть все параметры
          </div>
          <div class="flex flex-row flex-wrap m-[0.5rem] absolute top-[100%]">
            <div
              class="p-2 mr-[8px] my-[10px] lg:my-[0] rounded-lg bg-green-500"
              :class="{
                '!bg-green': isItemSelected(
                  currentFilterData.min_probeg,
                  'min_probeg',
                ),
              }"
              v-if="currentFilterData?.min_probeg"
            >
              <filter-item
                :item="currentFilterData.min_probeg"
                name="min_probeg"
                :hidden="true"
                :is-item-selected="isItemSelected(currentFilterData.min_probeg, 'min_probeg')
                  "
                @on-item-click="itemSelection"
              >
              </filter-item>
            </div>
            <div
              class="p-2 mr-[8px] my-[10px] lg:my-[0] rounded-lg bg-green-500"
              v-if="currentFilterData?.one_owner"
              :class="{
                '!bg-green': isItemSelected(
                  currentFilterData.one_owner,
                  'one_owner',
                ),
              }"
            >
              <filter-item
                :item="currentFilterData?.one_owner"
                name="one_owner"
                :hidden="true"
                :is-item-selected="isItemSelected(currentFilterData.one_owner, 'one_owner')
                  "
                @on-item-click="itemSelection"
              >
              </filter-item>
            </div>
            <div
              class="p-2 mr-[8px] my-[10px] lg:my-[0] rounded-lg bg-green-500"
              v-if="currentFilterData?.cool_cars"
              :class="{
                '!bg-green': isItemSelected(
                  currentFilterData.cool_cars,
                  'cool_cars',
                ),
              }"
            >
              <filter-item
                :item="currentFilterData?.cool_cars"
                name="cool_cars"
                :hidden="true"
                :is-item-selected="isItemSelected(currentFilterData.cool_cars, 'cool_cars')
                  "
                @on-item-click="itemSelection"
              >
              </filter-item>
            </div>
            <div
              class="p-2 mr-[8px] my-[10px] lg:my-[0] rounded-lg bg-green-500"
              v-if="currentFilterData?.for_family"
              :class="{
                '!bg-green': isItemSelected(
                  currentFilterData.for_family,
                  'for_family',
                ),
              }"
            >
              <filter-item
                :item="currentFilterData.for_family"
                name="for_family"
                :hidden="true"
                :is-item-selected="isItemSelected(currentFilterData.for_family, 'for_family')
                  "
                @on-item-click="itemSelection"
              >
              </filter-item>
            </div>
            <div
              class="p-2 mr-[8px] my-[10px] lg:my-[0] rounded-lg bg-green-500"
              v-if="currentFilterData?.has_warranty"
              :class="{
                '!bg-green': isItemSelected(
                  currentFilterData.has_warranty,
                  'has_warranty',
                ),
              }"
            >
              <filter-item
                :item="currentFilterData.has_warranty"
                name="has_warranty"
                :hidden="true"
                :is-item-selected="isItemSelected(currentFilterData.has_warranty, 'has_warranty')
                  "
                @on-item-click="itemSelection"
              >
              </filter-item>
            </div>
            <div
              class="p-2 mr-[8px] my-[10px] lg:my-[0] rounded-lg bg-green-500"
              v-if="currentFilterData?.nizkiy_nalog"
              :class="{
                '!bg-green': isItemSelected(
                  currentFilterData.nizkiy_nalog,
                  'nizkiy_nalog',
                ),
              }"
            >
              <filter-item
                :item="currentFilterData.nizkiy_nalog"
                name="nizkiy_nalog"
                :hidden="true"
                :is-item-selected="isItemSelected(currentFilterData.nizkiy_nalog, 'nizkiy_nalog')
                  "
                @on-item-click="itemSelection"
              >
              </filter-item>
            </div>
            <div
              class="p-2 mr-[8px] my-[10px] lg:my-[0] rounded-lg bg-red-100"
              v-if="currentFilterData?.novinki_nedeli"
              :class="{
                '!bg-red-300': isItemSelected(
                  currentFilterData.novinki_nedeli,
                  'novinki_nedeli',
                ),
              }"
            >
              <filter-item
                :item="currentFilterData.novinki_nedeli"
                name="novinki_nedeli"
                :hidden="true"
                :is-item-selected="isItemSelected(
                  currentFilterData.novinki_nedeli,
                  'novinki_nedeli',
                )
                  "
                @on-item-click="itemSelection"
              >
              </filter-item>
            </div>
          </div>
        </div>
        <div class="p-2 w-full lg:w-1/4 mb-[20px] lg:mb-[0] ml-auto">
          <button
            class="button button_big w-full border border-gray-800 border-1 bg-white clearFilter"
            @click="resetAllFilter"
          >
            Очистить фильтры
            <div class="mx-[10px]"><ClearFilter /></div>
          </button>
        </div>
        <div class="p-2 w-full lg:w-1/4">
          <button
            class="button button_green button_big w-full"
            @click="scrollToList"
          >
            {{
              `Найдено ${$options.priceFormat(currentCountCityCars)} ${$options.wordEnding(currentCountCityCars, ['автомобиль', 'автомобиля', 'автомобилей'])}`
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bordered {
  border: 2px solid #c5e1a2;
}
.clearFilter {
  color: #424349 !important;
  border: 1px solid #424349 !important;
  opacity: 0.3;
}
</style>
